import { create } from "../../../common/utils/zustand_state_manager";
import { IFinanceiroService } from "../../../features/financeiro/data/services/financeiro_service";
import { FinanceiroService } from "../../../features/financeiro/data/services/financeiro_service_impl";


/**
 * usefinanceiroServices
 */

type State = {
  financeiroService: IFinanceiroService,
};

export const useFinanceiroServices = create<State>((set, get) => ({
  financeiroService: new FinanceiroService(),
}));